<template>
    <div class="container containerBox choosemeter">
        <el-form label-width="120px" :model="form">
            <div class="title">基础数据选择</div>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="集控器/直连设备">
                        <el-select placeholder="请选择集控器" clearable v-model="form.gateWayId" @change="handleChosegateWayId">
                            <el-option
                                v-for="v in gatewayList"
                                :key="v.oid"
                                :label="v.dev_name"
                                :value="v.oid">
                                    <span style="float: left">{{ v.dev_name }}</span>
                                    <span style="float: right; color: #8492a6; font-size: 13px">{{ v.dev_serial }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="表计类型">
                        <el-select v-model="form.devtype" clearable placeholder="请选择表计类型" @change="handleChoseDevtype">
                            <el-option
                                key="0"
                                label="全部"
                                :value="0">
                            </el-option>
                            <el-option
                                v-for="v in devtype"
                                :key="v.value"
                                :label="v.label"
                                :value="v.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 当量温控器 -->
            <template v-if="form.devtype != undefined && form.gateWayId && bool">
                <div class="title" style="display: flex;">{{strDevType}}</div>
                <div style="width:70%;margin:0 auto;">
                    <el-form-item label="安装位置">
                        <cmp-build-select :buildRoom="buildRoom" @listenBuildResult="listenBuildResult"></cmp-build-select>
                    </el-form-item>
                    <!-- <el-form-item label="当前读数">
                        <el-input
                            placeholder="请输入当前读数"
                            v-model="form.household_value"
                            >
                        </el-input>
                    </el-form-item> -->
                    <el-form-item label="表计选择">
                        <el-input
                            placeholder="请选中表计表号"
                            v-model="form.TerminalSerial"
                            :readonly="true"
                            @focus="handleChoseMeter"
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSave">保存</el-button>
                    </el-form-item>
                </div>
            </template>
        </el-form>

        <!-- 选择表计型号组件 -->
        <cmp-chose-meter :visible="visibleChoseMeter" :addForm="addForm" @handleCloseDialog="handleCloseDialog"></cmp-chose-meter>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
import CmpChoseMeter from './CmpChoseMeter';
import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'
export default {
    name: "MeterSearch",
    inject: ["reload"],
    data() {
        return {
            gatewayList: [{
				dev_name :'直连设备',
				dev_serial:'',
				oid:'directly'
			}
				
			],    //  集控器列表
            form: {},
            devtype:[],
            addForm: {},    //  查询未绑定表计参数
            visibleChoseMeter: false,
            
            // 选择房间组件
            buildRoom: {},

            bool: true,
        };
    },
    computed: { 
        // 项目，项目列表
        ...mapGetters(['baseData']),
        strDevType() {
            let str = '全部'
            this.baseData.devtype.map(v=>{
                if(this.form.devtype === v.value){
                    str = v.label
                }
            })
            return str
        }
    },
    components: {
        CmpChoseMeter,
        CmpBuildSelect
    },
    created() {
		this.devtype = this.baseData.devtype;
        this.getCollectList();
    },
    methods: {
        // 获取集控器
        async getCollectList() {
            let data = await Service.getCollector();
            if(data) {
                data = data == 'success' ? [] : data;
                this.gatewayList =this.gatewayList.concat(data) ;
            }
        },
		//选择直连设备
		handleChosegateWayId(val){
			if(val == "directly"){
				this.devtype = [
					{
						value:1,
						label:"温控器"
					}
				]
			}else{this.devtype = this.baseData.devtype}
		},
        // 选择表计类型
        handleChoseDevtype(val) {
            this.form.meterType = val;
        },
        // 选择表计型号
        handleChoseMeter() {
            let {devtype, gateWayId} = this.form;
            this.addForm = {
                devtype,
                linked_collector_id: gateWayId
            };
            this.visibleChoseMeter = true;
        },
        handleCloseDialog(data) {
            if(data.flag){
                this.form.terminalid = data.item.oids;   //  表计ID
                this.form.TerminalSerial = data.item.str_terminal;    //  表计序列号
            }
            this.visibleChoseMeter = false;
        },
        // 确认房间ID
        listenBuildResult(data) {
            // if(data.terminalid>0){
            //     this.$notify({
            //         title: '警告',
            //         message: '该房间已经绑定了表计，请重新选择！',
            //         type: 'warning'
            //     });
            //     return
            // }
			if(data.householdid === undefined) {
			    // 建筑
			    this.form.is_house = false
			}else{
			    // 房间
			    this.form.is_house = true
			}
            this.form.oid = data.oid;
            // 不需要修改当前读数
            // this.getHouseMeterRead(data.OID);
        },
        async getHouseMeterRead(oid) {
            let data = await Service.getTerminalValuebytId({oid: oid});
            if(data) {
                this.form.household_value = data.HouseHoldValue;
            }
        },
        // 确认表计注册
        async handleSave() {
            let {oid, terminalid, household_value} = this.form;
            if(!oid || !terminalid) return
            let data = await Service.meterBindingHouse2({oid, terminalid, household_value});
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.bool = false;
                this.$nextTick(()=>{
                    this.form.TerminalSerial = '';
                    this.form.household_value = '';
                    this.bool = true;
                })
            }
        }
    },
};
</script>
<style>
.choosemeter .el-dialog__body {
    padding-top: 12px !important;
}
</style>

<style scoped>
.title {
    padding: 4px;
    margin-bottom: 24px;
    font-size: 18px;
    border-bottom: 1px solid #dcdfe6;
}
.wrapper {
    padding: 24px;
    background: #fff;
}
.unit {
    display: block;
    width: 50px;
    padding-left: 10px;
    font-size: 12px;
}
</style>
